type Method = 'GET' | 'POST' | 'DELETE' | 'HEAD' | 'PATCH';

type IApiResponseSuccess<T> = T & { success: true };
interface IApiResponseFailure {
    success: false;
    error: string;
}

type IApiResponse<T> = IApiResponseSuccess<T> | IApiResponseFailure;

export type ApiRequestFn = <T>(method: Method, resource: string, body?: Record<string, string | undefined> | FormData) => Promise<T>;

export function createApiClient(session: string | undefined) {
    async function apiRequest<T>(method: Method, resource: string, body?: Record<string, string | undefined> | FormData): Promise<T> {
        const url = new URL(`/api/v1/${resource}`, window.location.href);

        const isQueryString = method === 'GET' || method === 'HEAD';

        if (body !== undefined) {
            if (isQueryString) {
                if (body instanceof FormData) {
                    throw new Error('Forbidden use FormData in GET/HEAD request');
                }

                Object.entries(body).forEach(([key, value]) => {
                    if (value !== undefined) {
                        url.searchParams.append(key, value);
                    }
                });

                body = undefined;
            } else if (!(body instanceof FormData)) {
                body = Object.entries(body).reduce((fd, [key, value]) => {
                    if (value !== undefined) {
                        fd.append(key, value);
                    }

                    return fd;
                }, new FormData());
            }
        }

        const headers: HeadersInit = {};

        if (session) {
            headers.Authorization = `Bearer ${session}`;
        }

        const request = await fetch(url, { method, body, headers });

        const response = await request.json() as IApiResponse<T>;

        if (response.success) {
            return response;
        }

        throw new Error(response.error);
    }

    return apiRequest;
}
